import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DraftDepotRequeteService } from '../../../depot-requete/draft-depot-requete.service';
import { DraftRequete } from '../../../entities/draft-requete/draft-requete.model';

@Component({
    selector: 'jhi-draft-modal',
    templateUrl: './draft-modal.component.html',
    styleUrls: ['./draft-modal.component.scss']
})

/**
 * Modal to take back a draft or create a new requete
 */
export class DraftModalComponent implements OnInit {
    @Input() requete: DraftRequete;

    constructor(
        public activeModal: NgbActiveModal,
        private draftDepotRequeteService: DraftDepotRequeteService
    ) {}

    ngOnInit(): void {
        // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Suppression de votre brouillon en cours');
    }

    deleteMyDraftRequete() {
        this.draftDepotRequeteService.deleteMyDraftRequete().subscribe(() => {
            this.draftDepotRequeteService.eventDraftDeleted.emit();
            this.activeModal.close();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/draft-modal/draft-modal.component.ts